import * as React from "react";

const SvgTick = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <path
      fill="none"
      stroke="#fff"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="60"
      d="M416 128L192 384 96 288"
    ></path>
  </svg>
);

export default SvgTick;
